import axios, { AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios'
// @ts-ignore
import { env } from '@/state/env'
// @ts-ignore
import { user } from '@/state/user'
import CryptoJS from 'crypto-js'

function sign_param(param: any) {
  param.timestamp = Math.floor(new Date().getTime() / 1000).toString()
  param.nonce = Math.floor(Math.random() * 9000000000 + 1000000000).toString()
  param.access_key = 'aa8396d1c7bc42bc89462a196879f9bd'
  var string_a = Object.keys(param)
    .filter(key => key !== 'version')
    .sort()
    .map(function (key) {
      return [key, param[key]].join('=')
    })
    .join('&')
  var string_sign_temp = [string_a, 'secret_key=dd1ad7ddb8d84801ae182794732003e5'].join('&')
  var sign = CryptoJS.SHA1(string_sign_temp).toString().toUpperCase()
  param.sign = sign
  return param
}

class Request {
  private instance
  constructor() {
    this.instance = axios.create({
      baseURL: (import.meta as any).env.VITE_APP_BASE_API || '',
      timeout: 10e3,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    this.instance.interceptors.request.use(
      config => {
        const actualParams = sign_param(config.params || config.data)
        if (!actualParams['app-language']) {
          actualParams['app-language'] = env.language
        }
        config.headers = new axios.AxiosHeaders({
          ...config.headers,
          ...{
            'client-platform': 'web',
            'Access-Token': user.access_token,
            'App-Language': actualParams['app-language'] || env.language,
            'App-Platform': env.platform,
            'App-Version': env.version || actualParams['version'],
            'Device-Id': localStorage.getItem('device_id'),
            ...(localStorage.getItem('token-scene') && { 'Token-Scene': localStorage.getItem('token-scene') }),
            // 'no-validate': 1,
          },
        })
        config.params = actualParams
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )

    this.instance.interceptors.response.use(
      response => {
        return response.data
      },
      error => {
        return Promise.reject(error)
      }
    )
  }

  get(url: string, params = {}) {
    return this.instance.get(url, { params })
  }

  post(url: string, data = {}) {
    return this.instance.post(url, data)
  }
}

export default new Request()
